// TODO(guest-app): Switch to existing date helper under components/DatePickers
export const formatDate = (date) => {
  const dateTimeString = date.toString()
  const dateTimeArray = dateTimeString.split(" ")
  const formattedDate = dateTimeArray.slice(0, 4).join(" ")
  return formattedDate
}
